import React from 'react';
import {ConfirmationServiceProvider} from '../ConfirmationService';

/**
 * wrap component in confirmation
 * @example
	const WrappedComponenet = withConfirmation(Componenet);
 */
export const withConfirmation = function <C extends React.ElementType>(
	Component: C,
) {
	return (
		props: JSX.IntrinsicAttributes &
			JSX.LibraryManagedAttributes<C, React.ComponentProps<C>>,
	) => {
		return (
			<ConfirmationServiceProvider>
				<Component {...props} />
			</ConfirmationServiceProvider>
		);
	};
};

export default withConfirmation;
